export const getTextFieldStyle = (touched, error) => ({
    width: '100%',
    '& .MuiOutlinedInput-root': {
        borderRadius: 3,
        backgroundColor: '#ffffff',
        transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
        '& fieldset': { borderColor: '#e2e8f0', borderWidth: '1.5px' },
        '&:hover fieldset': { borderColor: 'primary.main' },
        '&.Mui-focused fieldset': { borderColor: 'primary.main', borderWidth: '2px', boxShadow: (theme) => `0 0 0 4px ${theme.palette.primary.main}1a` },
        '&.MuiInputBase-root:not(.Mui-error) fieldset': {
            borderColor: (touched && !error) ? '#10b981' : '#e2e8f0',
        },
    },
    '& .MuiFormHelperText-root': {
        marginLeft: 0,
        marginTop: 0.5,
        fontWeight: 600,
        fontSize: '0.75rem'
    }
});

export const selectStyle = {
    width: '100%',
    borderRadius: 3,
    backgroundColor: "#ffffff",
    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e2e8f0', borderWidth: '1.5px' },
    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'primary.main' },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'primary.main', borderWidth: '2px' },
    '& .MuiSelect-select': { py: 1.5, fontWeight: 500 }
};

/**
 * Converts a flat list of org nodes (with parent_id) into a
 * depth-first ordered array for hierarchical dropdown display.
 * Returns: [{ ...node, _depth: number }, ...]
 */
export const buildHierarchicalList = (nodes) => {
    const byId = {};
    const roots = [];
    nodes.forEach(n => { byId[n.id] = { ...n, _children: [] }; });
    nodes.forEach(n => {
        if (n.parent_id && byId[n.parent_id]) {
            byId[n.parent_id]._children.push(byId[n.id]);
        } else {
            roots.push(byId[n.id]);
        }
    });
    const sortLevel = (arr) => arr.sort((a, b) => a.node_name.localeCompare(b.node_name));
    const result = [];
    const traverse = (node, depth) => {
        const { _children, ...rest } = node;
        result.push({ ...rest, _depth: depth });
        sortLevel(_children).forEach(child => traverse(child, depth + 1));
    };
    sortLevel(roots).forEach(r => traverse(r, 0));
    return result;
};

export const toInputDate = (v) => {
    if (!v) return "";
    const d = new Date(v);
    if (Number.isNaN(d.getTime())) return "";
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
};
